import React from "react";
import x1921 from "../../images/x1921.png";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const Header: React.FC = () => {
  const navigate = useNavigate();
  const activeClass = "font-bold text-[#fa0053]"; // Active route style
  const normalClass = "text-black-700 hover:text-[#0C0407] hover:font-bold transition duration-300";
  const location = useLocation();
  
  const handleTutorials = () => {
    navigate(`/tutorials`);
  }

  const handleNavigateToContact = () => {
    navigate('/contact');
  }

  return (
    <header className="w-full py-4 border-b border-gray-200">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="https://merakzy.com" target="_blank" rel="noopener noreferrer">
          <img src={x1921} alt="Merakzy Logo" className="w-40 h-auto cursor-pointer" />
        </a>

        {/* Menu Items */}
        <nav className="hidden md:flex gap-8 mx-auto">
          <NavLink to="/" className={({ isActive }) => isActive ? activeClass : normalClass}>
            Дома
          </NavLink>
          <NavLink to="/about" className={({ isActive }) => isActive ? activeClass : normalClass}>
            За нас
          </NavLink>
          <NavLink to="/blog" className={({ isActive }) => isActive ? activeClass : normalClass}>
            Блог
          </NavLink>
          <NavLink to="/contact" className={({ isActive }) => isActive ? activeClass : normalClass}>
            Контакт
          </NavLink>
        </nav>

        {/* Button */}
        <>
          {location.pathname !== "/tutorials" ? (
            <button
              className="hidden md:flex items-center gap-2 bg-[#fa0053] text-white rounded-[16px] px-6 py-3 hover:opacity-90 transition"
              onClick={handleTutorials}
            >
              Tуторијали
            </button>
          ) : (
            <button
              className="hidden md:flex items-center gap-2 bg-[#fa0053] text-white rounded-[16px] px-6 py-3 hover:opacity-90 transition"
              onClick={handleNavigateToContact}
            >
              Побарајте демо
            </button>
          )}
        </>
      </div>
    </header>
  );
};

export default Header;